(function () {
  function getUTMParams() {
    const params = new URLSearchParams(window.location.search);
    const utms = {};
    for (const [key, value] of params.entries()) {
      if (key.startsWith("utm_")) {
        utms[key] = value;
      }
    }
    return utms;
  }

  const currentUTMs = getUTMParams();
  if (Object.keys(currentUTMs).length > 0) {
    sessionStorage.setItem("utmParams", JSON.stringify(currentUTMs));
  }

  function getStoredUTMParams() {
    const stored = sessionStorage.getItem("utmParams");
    return stored ? JSON.parse(stored) : {};
  }

  document.addEventListener("DOMContentLoaded", function () {
    const utms = getStoredUTMParams();
    if (Object.keys(utms).length === 0) return;

    const botoes = document.querySelectorAll(
      'a.subscribe-button, a[href*="cgi.insper.edu.br/Inscricao/lead"]'
    );

    // Batch reads: compute all new hrefs before touching the DOM
    const updates = Array.from(botoes).map((link) => {
      const url = new URL(link.href);
      for (const key in utms) {
        url.searchParams.set(key, utms[key]);
      }
      return { link, href: url.toString() };
    });

    // Batch writes: apply all href changes in one pass
    updates.forEach(({ link, href }) => {
      link.href = href;
    });
  });
})();
